import React, { useState } from 'react';

export default function Navigation({ onAdminClick }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav>
      <div className="logo">
        <span className="logo-icon">◆</span>
        <span className="logo-text">Tem<span>pes</span></span>
      </div>

      <ul className="nav-menu">
        <li><a href="#home">Home</a></li>
        <li><a href="#documents">Documents</a></li>
        <li><a href="#clients">Clients</a></li>
        <li><a href="#tokenomics">Tokenomics</a></li>
        <li><a href="#media">Media</a></li>
      </ul>


      <button
        className="hamburger-btn"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {mobileMenuOpen && (
        <div className="mobile-menu active">
          <div className="mobile-menu-content">
            <div className="mobile-menu-header">
              <div className="logo">
                <span className="logo-icon">◆</span>
                <span className="logo-text">Tem<span>pes</span></span>
              </div>
              <button
                className="close-menu-btn"
                onClick={() => setMobileMenuOpen(false)}
              >
                ✕
              </button>
            </div>

            <ul className="mobile-nav-menu">
              <li><a href="#home" onClick={() => setMobileMenuOpen(false)}>Home</a></li>
              <li><a href="#documents" onClick={() => setMobileMenuOpen(false)}>Documents</a></li>
              <li><a href="#clients" onClick={() => setMobileMenuOpen(false)}>Clients</a></li>
              <li><a href="#tokenomics" onClick={() => setMobileMenuOpen(false)}>Tokenomics</a></li>
              <li><a href="#media" onClick={() => setMobileMenuOpen(false)}>Media</a></li>
            </ul>

          </div>
        </div>
      )}
    </nav>
  );
}
